import assignWith from "lodash/assignWith";
function mergeWithDefined() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return assignWith.apply(void 0, [{}].concat(args, [function (prev, next) {
    return next === undefined ? prev : next;
  }]));
}
export default mergeWithDefined;